/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/
import type { HalfEdge } from 'application/render/view-model/HalfEdge';
import { Bond } from 'domain/entities/bond';

export class Loop {
  public doubleBondsAmount = 0;
  public aromatic = true;

  constructor(public halfEdges: Array<HalfEdge>, public isConvex = false) {
    this.calculateDoubleBondsAmount();
  }

  private calculateDoubleBondsAmount() {
    this.halfEdges.forEach((halfEdge) => {
      if (halfEdge.bond.type !== Bond.PATTERN.TYPE.AROMATIC)
        this.aromatic = false;
      if (halfEdge.bond.type === Bond.PATTERN.TYPE.DOUBLE)
        this.doubleBondsAmount++;
    });
  }
}
